module.exports = __webpack_public_path__ + "static/864430134-wide.675e47a1.jpg";